import createDateTimeString from "@/components/widgets/dashboard/calendar/eventModal/form/createDateTimeString";
import draftToHtml from "@/components/writeMail/draftToHtml";
import type AgendaItem from "@/domain/entities/agenda/AgendaItem";
import CreateAgendaItemData from "@/domain/entities/agenda/CreateAgendaItemData";
import {
    startOfCalendarDay,
    toAllDayApiEndDate,
    toAllDayDisplayEndDate,
} from "@/lib/agendaAllDayDates";

const hourOf = (date: Date) =>
    `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

/**
 * The event the assistant proposed, as « Créer l'événement » sends it: the same dates as the edit form
 * would send untouched (EventEditForm: an all-day event from midnight to the day after its last day,
 * in local time), and the agenda as paragraphs, escaped (nothing of the model's is read as HTML).
 */
const eventProposalToCreateData = (event: AgendaItem): CreateAgendaItemData => {
    const isAllDay = event.isAllDayEvent();
    const start = createDateTimeString(
        isAllDay ? startOfCalendarDay(event.start) : event.start,
        isAllDay ? "00:00" : hourOf(event.start),
        isAllDay,
    );
    const end = createDateTimeString(
        isAllDay
            ? toAllDayApiEndDate(toAllDayDisplayEndDate(event.start, event.end))
            : event.end,
        isAllDay ? "00:00" : hourOf(event.end),
        isAllDay,
    );

    return new CreateAgendaItemData({
        subject: event.subject,
        start: start ?? "",
        end: end ?? "",
        location: event.location?.displayName,
        attendees: event.attendees.map(
            (attendee) => attendee.emailAddress.address,
        ),
        description: event.bodyPreview ? draftToHtml(event.bodyPreview) : "",
        isAllDay,
    });
};

export default eventProposalToCreateData;
